import React from "react";
const FormBuilderFormInterfaceSpacer = ({ item }) => {
  return /* @__PURE__ */ React.createElement("div", { id: item.id, className: `${item.class}` });
};
FormBuilderFormInterfaceSpacer.displayName = "FormBuilderFormInterfaceSpacer";
export default FormBuilderFormInterfaceSpacer;
